import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlReceita = '/service/planejamentoEstrategico/indicadores/'

class UnidadeMedidaIndicadoresService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getUnidadeMedida() {
        return this.conex.get(urlReceita + 'unidadeMedida/')
    }
}

export default UnidadeMedidaIndicadoresService
